<template>
  <v-row justify="center">
    <v-dialog v-model="dialogWish" width="60%" max-height="80%">
      <template v-slot:activator="{ on }">
        <div class="row justify-content-center align-items-center">
          <p
            class="mb-0 mr-2"
            style="
              color: #3b3838;
              text-align: center;
              font-weight: 600;
              font-size: 1.25rem !important;
            "
          >
            {{ $t("wish.wish") }}
          </p>
          <v-btn
            rounded
            color="#e6007e"
            v-on="on"
            class="text-white"
            style="font-weight: 600; font-size: 1.1rem !important"
          >
            {{ $t("wish.wishButton") }}
            <v-img
              style="position: absolute; right: -40px; top: -45px"
              contain
              width="40"
              height="40"
              src="/media/svg/icons/Communication/Chat-Group2.png"
            />
          </v-btn>
        </div>
      </template>
      <v-form class="form-wish" ref="form">
        <v-card style="background-color: #eeeeee">
          <v-card-text>
            <div>
              <v-row>
                <v-col class="text-left pt-0">
                  <v-btn @click="dialogWish = false" color="#e6007e" fab x-small>
                    <v-icon color="white">fas fa-times</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Zone de texte pour saisie du souhait client -->
              <v-textarea
                v-model="wish"
                background-color="white"
                counter
                filled
                auto-grow
                rounded
                clearable
                clear-icon="mdi-close-circle"
                :placeholder="$t('wish.placeholderTextArea')"
                :rules="wishErrors"
              ></v-textarea>

              <!-- Acceptation des conditions de contact -->
              <div class="row">
                <div class="col-sm-9">
                  <v-checkbox
                    v-model="allowContact"
                    color="pink darken-3"
                    hide-details
                  >
                    <template v-slot:label>
                      <span style="font-size: 0.85rem">{{
                        $t("wish.labelAllowContact")
                      }}</span>
                    </template>
                  </v-checkbox>
                </div>
                <div class="col-sm-3 align-self-end text-center">
                  <v-btn
                    width="50%"
                    color="#e6007e"
                    class="text-white"
                    style="font-weight: 600; font-size: 1.1rem !important"
                    @click="submit"
                  >
                    {{ $t("wish.submitWish") }}
                  </v-btn>
                </div>
              </div>
            </div>
          </v-card-text>

          <v-card-actions> </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import Api from "../../core/services/api.service";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";

export default {
  name: "formWish",
  data() {
    return {
      dialogWish: false,
      allowContact: false,
      valid: false,
      wish: "",
      wishErrors: [
        (v) => !!v || this.$t("wish.errors.empty"),
        (v) => v && v.length >= 30 || this.$t("wish.errors.short"),
        (v) => v && v.length <= 500 || this.$t("wish.errors.exceed"),
      ],
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
  },
  props: {
    mode: String,
    search: String,
    searchResultNumber: String,
    video: String,
    theme: String,
  },
  methods: {
    getExtraInformation() {
      return (
        "search:" +
        (!this.search ? "null" : this.search) +
        "|" +
        "searchResultNumber:" +
        (!this.searchResult ? "null" : this.searchResult) +
        "|" +
        "video:" +
        (!this.video ? "null" : this.video) +
        "|" +
        "theme:" +
        (!this.theme ? "null" : this.theme)
      );
    },
    submit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        // Création de la soumission du formulaire
        Api.post("wishes", {
          user: this.currentUser["@id"],
          message: this.wish,
          allowContact: this.allowContact,
          mode: this.mode,
          extraInformation: this.getExtraInformation(),
          status: "NEW",
        })
          .then(() => {
            this.dialogWish = false;
            this.wish = "";
            this.allowContact = false;
            Swal.fire({
              title: this.$t("wish.submit.title"),
              text: this.$t("wish.submit.successText"),
              icon: "success",
            });
          })
          .catch(() => {
            this.dialogWish = false;
            Swal.fire({
              title: this.$t("wish.submit.title"),
              text: this.$t("wish.submit.errorText"),
              icon: "error",
            });
          });
      }
    },
  },
};
</script>
